import { SpaceProps as StyledSpaceProps, LayoutProps as StyledLayoutProps } from 'styled-system'

export const space = [
  '0rem',
  // xs
  '0.25rem', // 4px
  '0.5rem', // 8px
  '0.75rem', // 12px
  '1rem', // 16px
  '1.25rem', // 20px
  '1.5rem', // 24px

  // sm
  '2rem', // 32px
  '2.5rem', // 40px
  '3rem', // 48px
  '3.5rem', // 56px
  '4rem', // 64px

  // md
  '5rem', // 80px
  '6rem', // 96px
  '7rem', // 112px
  '8rem', // 128px
  '9rem', // 144px

  // lg
  '11rem', // 176px
  '13rem', // 208px
  '15rem', // 240px
  '17rem', // 272px
  '19rem', // 304px

  // xl
  '23rem', // 368px
  '27rem', // 432px
  '31rem', // 496px
  '35rem', // 560px
  '39rem', // 624px

  // 2xl
  '47rem', // 752px
  '55rem', // 880px
  '63rem', // 1008px
  '71rem', // 1136px
  '79rem', // 1264px

  // 3xl
  '95rem', // 1520px
  '111rem', // 1776px
  '127rem', // 2032px
  '143rem', // 2288px
  '159rem', // 2544px
]

export const settings = {
  sizes: space,
  space,
}

export type Sizes = number[] | string[]

export interface SpaceTheme {
  sizes: Sizes
  space: Sizes
}

type AliasesProps = number | string | Array<number | string>

export type SpaceProps = StyledSpaceProps &
  StyledLayoutProps & {
    /**
   @example
   ```
   0   | 1   | 2   | 3    | 4    | 5    | 6    | 7    | 8
   0px | 4px | 8px | 12px | 16px | 20px | 24px | 32px | 40px

   more...
   ```
   */
    h?: AliasesProps
    /**
   @example
   ```
   0   | 1   | 2   | 3    | 4    | 5    | 6    | 7    | 8
   0px | 4px | 8px | 12px | 16px | 20px | 24px | 32px | 40px

   more...
   ```
   */
    w?: AliasesProps
  }
